import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { FC, ReactNode, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { RecoilRoot, useRecoilValue } from 'recoil';
import { ThemeProvider } from 'styled-components';

import GlobalStyle from '@/assets/styles/global';
import { Toasts } from '@/components';
import { PORTAL } from '@/constants';
import { SectionName, useIsLoadedState } from '@/context';
import { useBot, useSection } from '@/hooks';
import { useAccessControl } from '@/hooks/use-access-control';
import { Home, ResponsibleForm, Skeleton, TermsForm } from '@/pages';

import { Container } from './styled';

const sections: Record<SectionName, ReactNode> = {
  home: <Home />,
  termsForm: <TermsForm />,
  responsibleForm: <ResponsibleForm />,
};

const Feature: FC = () => {
  const { section } = useSection();
  useBot('Olá! Como posso te ajudar?');

  return sections[section];
};

const Main: FC = () => {
  const { isAccessValidated } = useAccessControl();
  const isLoaded = useRecoilValue(useIsLoadedState);
  const isAllValidated = useMemo(() => isAccessValidated && isLoaded, [isAccessValidated, isLoaded]);

  return isAllValidated ? <Feature /> : <Skeleton />;
};

export const RiskManagementOnboarding: FC = () => (
  <ThemeProvider theme={dsTokens}>
    <RecoilRoot>
      {createPortal(<Toasts />, document.body)}
      <GlobalStyle />
      <Container>
        <Main />
      </Container>
      <div className={PORTAL} />
    </RecoilRoot>
  </ThemeProvider>
);

export default RiskManagementOnboarding;
